
export function showError(message) {
    alert(message)
}
export function showSuccessMessage(message) {
    alert(message)
}
export function askConfirmation(message) {
    return window.confirm(message)
}